import React, { useState } from "react";
import CustomModal from "../../modal";
import { useTranslation } from "react-i18next";
import { IoCloseOutline, IoTrash } from "react-icons/io5";
import { useSelector, useDispatch } from "react-redux";
import {
  setVisible,
  setTitle,
  setDescription,
} from "../../../store/slices/customCategory";
import Prompt from "../../modal/prompt";

import styles from "./soloModals.module.css";

export default function AddCategorySolo({ edit, onSave, onDelete }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [confirm, setConfirm] = useState(false);
  const { visible, title, description } = useSelector(
    (state) => state.customCategory
  );

  const handleClose = () => {
    dispatch(setVisible(false));
  };

  const handleSave = () => {
    if (!title || !description) {
      if (!title)
        document
          .getElementById("category-input")
          .classList.add(styles["input-error"]);
      if (!description)
        document
          .getElementById("description-input")
          .classList.add(styles["input-error"]);
      return;
    }

    onSave({ title, description });
    handleClose();
  };

  const afterClose = () => {
    if (edit) return;
    dispatch(setTitle(""));
    dispatch(setDescription(""));
  };

  const handleShouldDelete = () => {
    setConfirm(true);
  };

  const handleDelete = () => {
    setConfirm(false);
    setTimeout(() => {
      onDelete();
      handleClose();
    }, 300);
  };

  const onFocus = (e) => {
    e.target.classList.remove(styles["input-error"]);
  };

  return (
    <div>
      <CustomModal
        className="w-full"
        visible={visible}
        handleClose={handleClose}
        handleAfterClose={afterClose}
      >
        <div className={styles.card}>
          <div className="flex items-center">
            <button
              className="pt-3 -mt-3 ps-3 -ms-3 touchable-opacity"
              onClick={handleClose}
            >
              <IoCloseOutline size={32} />
            </button>
            <div className="flex-1 text-center">
              <h2 className="font-bold text-xl">{t("cadastrarCategory")}</h2>
            </div>
            {edit ? (
              <button
                className="pt-3 -mt-3 pe-3 -me-3 touchable-opacity"
                onClick={handleShouldDelete}
              >
                <IoTrash size={26} />
              </button>
            ) : (
              <div style={{ width: "26px" }}></div>
            )}
          </div>
          <hr className="border-[#6A6C71]" />
          <div className="flex flex-col gap-5 mt-3">
            <div className="flex flex-col">
              <label className={styles.label}>{t("categoryLabel")}</label>
              <input
                className={styles.input}
                type="text"
                value={title}
                id="category-input"
                onFocus={onFocus}
                onChange={(e) => dispatch(setTitle(e.target.value))}
              />
            </div>
            <div className="flex flex-col">
              <label className={styles.label}>{t("descriptionLabel")}</label>
              <textarea
                rows={3}
                className={styles.input}
                value={description}
                id="description-input"
                onFocus={onFocus}
                onChange={(e) => dispatch(setDescription(e.target.value))}
              />
            </div>
            <button
              onClick={handleSave}
              className="btn btn-brand btn-small pt-2 pb-2"
            >
              {t("save")}
            </button>
          </div>
        </div>
      </CustomModal>
      <Prompt
        visible={confirm}
        title={"Tem certeza?"}
        description={"Isso excluira permanentemente esta categoria"}
        handleConfirm={handleDelete}
        handleCancel={() => setConfirm(false)}
      />
    </div>
  );
}
